import * as Yup from "yup"

export const vehicleAlarmNotificationValidationSchema = (t) =>
  Yup.object().shape({
    alarmType: Yup.number()
      .nullable()
      .required(t("vehiclealarm.you_must_specify_alarm_type", "You must specify alarm type")),
    userId: Yup.number()
      .nullable()
      .required(t("vehiclealarm.you_must_specify_user", "You must specify user")),
    companyId: Yup.number()
      .nullable()
      .required(t("global.you_must_specify_a_company", "You must specify a company"))
  })
